/**
 * <reveal-element>
 * A high-performance wrapper for scroll-triggered animations.
 */
class RevealElement extends HTMLElement {
  constructor() {
    super()
    // Single observer instance shared across all components (Memory Efficient)
    this.observer = new IntersectionObserver(this.handleIntersect.bind(this), {
      root: null, // viewport
      threshold: 0.1, // trigger when 10% is visible
      rootMargin: "0px 0px -80px 0px", // offset to trigger slightly before it hits bottom
    })
  }

  connectedCallback() {
    // Only observe if the user hasn't opted out via prefers-reduced-motion
    if (!window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      this.observer.observe(this)
    } else {
      this.dataset.visible = "true"
    }
  }

  disconnectedCallback() {
    this.observer.disconnect()
  }

  handleIntersect(entries) {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        this.dataset.visible = "true"
        // Unobserve after firing to save CPU cycles (one-time animation)
        this.observer.unobserve(this)
      }
    })
  }
}

if (!customElements.get("reveal-element")) {
  customElements.define("reveal-element", RevealElement)
}
